import { createSelector } from 'reselect';
import moment from 'moment';

const statePolicySelector = (state) => state.policy.items;

export const autoIdCardsSelector = createSelector([statePolicySelector], (policies) => {
	let autoIdCardPolicies = policies
		.filter((p) => ['Future', 'In-Force', 'Pending'].includes(p.status))
		.filter((p) => (p.cards !== null && p.cards.filter((c) => c.year !== 0).length > 0) || p.policyNumber.includes('GAR') || (p.policyNumber.includes('CPP') && p.packageParts && p.packageParts.filter((pp) => pp.name === 'Garage').length > 0))
		.map((p) => {
			return {
				nickname: p.nickname,
				policyNumber: p.policyNumber,
				type: p.type,
				effective: `${moment(p.term.effectiveDate).format('MM/DD/YYYY')}`,
				expiration: `${moment(p.term.endDate).format('MM/DD/YYYY')}`,
				statusText: p.status === 'History' ? 'Cancelled' : p.status,
				cards: p.cards !== null ? p.cards.filter((c) => c.year !== 0) : [],
			};
		});

	return { policies: autoIdCardPolicies };
});